import { Component, Inject, ViewChild, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from '../../core/layout/layout.component';
import { LeaveHistoryComponent } from './components/leave-history/leave-history.component';
import { LeaveService } from '../../features/leave/services/leave.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ImageService } from '../../shared/services/image.service';
import { PermissionService } from '../../shared/services/permission.service';
import { ModuleIds } from '../../shared/permission-constants/permission-const';

@Component({
  selector: 'app-leave-approvals',
  standalone: true,
  imports: [
    CommonModule,
    LayoutComponent,
    LeaveHistoryComponent
  ],
  templateUrl: './leave-approvals.component.html',
  styleUrl: './leave-approvals.component.scss'
})
export class LeaveApprovalsComponent {
  isDropdownOpen = false;
  employeeId: any = null;
  leaveData: any = null;
  leaveApprovers: any = null;
  leaveCount: any;
  leaveApprovals: any;
  levelOneId: any;
  levelTwoId: any;
  levelThreeId: any;
  levelFourId: any;
  levelOneApproverStatus: any;
  levelTwoApproverStatus: any;
  levelThreeApproverStatus: any;
  levelFourApproverStatus: any;
  leaveId: string;
  activityType: any;
  search: any;
  timelines: any;
  profileName: any;
  showBtn: boolean = false;
  levelFiveId: any;
  levelSixId: any;
  levelSevenId: any;
  levelFiveApproverStatus: any;
  levelSixApproverStatus: any;
  levelSevenApproverStatus: any;
  profilePicture: any;
  canApproveOrRejectLeave$ = this.permissionService.hasPermission(
    ModuleIds.Leave,
    'Approve/Reject'
  );
  canWithdrawLeave$ = this.permissionService.hasPermission(
    ModuleIds.Leave,
    'Withdraw'
  );

  constructor(
    private leaveService: LeaveService,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private imageService: ImageService,
    private permissionService: PermissionService

  ) { }

  ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.leaveId = id;
      this.fetchLeaves(id);
    }
    const loggedInUser: any = localStorage.getItem('loggedInUser');
    const userData = JSON.parse(loggedInUser);
    this.profileName = userData?.profileData?.profileName;
  }

  toggleDropdown(event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }
    this.isDropdownOpen = !this.isDropdownOpen;
    if (this.isDropdownOpen) {
      this.leaveService.fetchTimelines("LEAVE", Number(this.leaveId), this.activityType, this.search).subscribe({
        next: (data) => {
          this.timelines = data;
        },
        error: (error) => {
          this.toastr.error("Error in fetching timelines", 'Error')
        }
      })
    }
  }

  fetchLeaves(id: any) {
    this.leaveService.fetchLeaveById(id).subscribe({
      next: (data) => {
        const type = "LEAVE";
        this.employeeId = data?.employee?.id;
        this.getLeaveApprovals(data?.id, type);
        this.getLeaveCount(this.employeeId);
        this.leaveData = data;

        this.leaveApprovers = data?.employee?.employeeApprovers;

        this.leaveApprovers.map((leaveApprover: any) => {
          this.profilePicture = Array(7).fill('assets/images/dummy-profile-image.jpg');

          ['levelOneData', 'levelTwoData', 'levelThreeData', 'levelFourData', 'levelFiveData', 'levelSixData', 'levelSevenData']
            .forEach(async (level, index) => {
              const profilePictureData = leaveApprover?.[level]?.profilePicture;
              if (profilePictureData) {
                try {
                  this.profilePicture[index] = await this.imageService.getImageAsBase64(profilePictureData);
                  
                } catch (error) {
                  this.profilePicture[index] = 'assets/images/dummy-profile-image.jpg';
                }
              }
            });
          this.levelOneId = leaveApprover?.levelOneData?.id;
          this.levelTwoId = leaveApprover?.levelTwoData?.id;
          this.levelThreeId = leaveApprover?.levelThreeData?.id;
          this.levelFourId = leaveApprover?.levelFourData?.id;
          this.levelFiveId = leaveApprover?.levelFiveData?.id;
          this.levelSixId = leaveApprover?.levelSixData?.id;
          this.levelSevenId = leaveApprover?.levelSevenData?.id;
        })

        if (data?.leaveStatus === 'Pending') {
          this.showBtn = true;
        }
      },
      error: (error) => {
        this.toastr.error("Error in fetching leave", 'Error')
      }
    })
  }

  getLeaveApprovals(leaveId: any, type: any) {
    this.leaveService.getLeaveApprovals(leaveId, type).subscribe({
      next: (response) => {
        response.map((data: any) => {

          if (this.levelOneId === data?.approverId) {

            this.levelOneApproverStatus = data?.approvalStatus;
          } else if (this.levelTwoId === data?.approverId) {
            this.levelTwoApproverStatus = data?.approvalStatus;
          } else if (this.levelThreeId === data?.approverId) {
            this.levelThreeApproverStatus = data?.approvalStatus;
          } else if (this.levelFourId === data?.approverId) {
            this.levelFourApproverStatus = data?.approvalStatus;

          } else if (this.levelFiveId === data?.approverId) {
            this.levelFiveApproverStatus = data?.approvalStatus;

          } else if (this.levelSixId === data?.approverId) {
            this.levelSixApproverStatus = data?.approvalStatus;
          } else if (this.levelSevenId === data?.approverId) {
            this.levelSevenApproverStatus = data?.approvalStatus;
          }
          this.leaveApprovals = response?.leaveApprovals || [];
        })

      },
      error: (error) => {
        this.toastr.error("Error in fetching approvals", 'Error');
      }
    });
  }

  getLeaveCount(employeeId: any) {
    
    this.leaveService.getLeaveCount(employeeId).subscribe({
      next: (data) => {
        this.leaveCount = data;
      },
      error: (error) => {
        this.toastr.error("Error in fetching leave count", 'Error')
      }
    })
  }

  readonly dialog = inject(MatDialog);


  onReject() {
    const status = 2;
    const dialogRef = this.dialog.open(PayrollApprovalsDialog, {
      disableClose: true,
      data: { status: status, leaveId: this.leaveId },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getLeaveApprovals(this.leaveId, "LEAVE");
        this.fetchLeaves(this.leaveId);
        // this.getLeaveCount(this.employeeId);
        this.toastr.success('Leave request rejected successfully', 'Success');
      }
    });
  }

  onApprove() {
    const status = 1;
    const dialogRef = this.dialog.open(PayrollApprovalsDialog, {
      disableClose: true,
      data: { status: status, leaveId: this.leaveId },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getLeaveApprovals(this.leaveId, "LEAVE");
        this.fetchLeaves(this.leaveId);
        // this.getLeaveCount(this.employeeId);
        this.toastr.success('Leave request approved successfully', 'Success');
      }
    });
  }

  onCancel() {
    const status = 3;
    const dialogRef = this.dialog.open(PayrollApprovalsDialog, {
      disableClose: true,
      data: { status: status, leaveId: this.leaveId },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getLeaveApprovals(this.leaveId, "LEAVE");
        this.toastr.success('Leave request cancelled successfully', 'Success');
      }
    });
  }

}


@Component({
  selector: 'leave-approvals-dialog',
  templateUrl: 'leave-approvals-dialog.html',
  styleUrls: ['./leave-approvals.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    FormsModule
  ],
})
export class PayrollApprovalsDialog {
  @ViewChild('LeaveApprovalsComponent') LeaveApprovalsComponent: LeaveApprovalsComponent;
  status: number;
  approvedStatus: string = '';
  leaveId: number;
  applyApprovalForm: FormGroup;
  rejectedStatus: string;
  cancelledStatus: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private leaveService: LeaveService,
    private toastr: ToastrService,
    public dialogRef: MatDialogRef<PayrollApprovalsDialog>,
  ) { }

  ngOnInit() {
    this.status = this.data.status;
    this.leaveId = this.data.leaveId;
    this.applyApprovalForm = this.fb.group({
      approvalNote: ['', Validators.required],
    });
  }

  handleClick() {
    if (this.status) {
      this.onStatusUpdate(this.status);
    }
  }

  onStatusUpdate(status: number) {
    const statusMap: any = { 1: 'APPROVED', 2: 'REJECTED', 3: 'CANCELLED' };
    const selectedStatus = statusMap[status];
  
    if (selectedStatus) {
      this.leaveService.updateLeaveStatus(this.leaveId, selectedStatus, this.applyApprovalForm?.value?.approvalNote)
        .subscribe({
          next: (data) => this.dialogRef.close(data),
          error: (error) => this.toastr.error(error?.message, 'Error')
        });
    }
  }
  
}